module.exports = __webpack_public_path__ + "static/Holiday_Website-fda911b79954659182ba7ad46dcb3714.webp";